import { LanguageCode } from './language';

type TranslationDictionary = Readonly<Record<string, string>>;

const fr: TranslationDictionary = {
  'Choose the language for your account.': 'Choisissez la langue de votre compte.',
  Continue: 'Continuer',
  'Language updated successfully.': 'Langue mise à jour avec succès.',
  'The language could not be updated. Please try again.':
    "La langue n'a pas pu être mise à jour. Veuillez réessayer.",
  'Change language': 'Changer de langue',

  Work: 'Travail',
  Control: 'Contrôle',
  System: 'Système',
  Customers: 'Clients',
  Customer: 'Client',
  Inquiries: 'Demandes',
  Inquiry: 'Demande',
  Trips: 'Voyages',
  Trip: 'Voyage',
  Suppliers: 'Fournisseurs',
  Supplier: 'Fournisseur',
  Quotations: 'Devis',
  Quotation: 'Devis',
  Reports: 'Rapports',
  Administration: 'Administration',
  Users: 'Utilisateurs',
  User: 'Utilisateur',
  'Roles & Permissions': 'Rôles et autorisations',
  Company: 'Entreprise',
  'Exchange Rates': 'Taux de change',
  'All quotations': 'Tous les devis',
  'Manager approval': 'Approbation du responsable',
  Dashboard: 'Tableau de bord',
  'My Profile': 'Mon profil',
  'Change Password': 'Changer le mot de passe',
  'Sign out': 'Se déconnecter',
  Notifications: 'Notifications',
  'Close notification': 'Fermer la notification',
  Search: 'Rechercher',
  'Search across the workspace': "Rechercher dans l'espace de travail",
  'Global search is not connected yet': 'La recherche globale n’est pas encore connectée',
  'No production results are shown until a cross-module search API is available.':
    'Aucun résultat de production n’est affiché tant qu’une API de recherche intermodule n’est pas disponible.',
  'Customers, trips, suppliers, inquiries and quotations.':
    'Clients, voyages, fournisseurs, demandes et devis.',
  'No role': 'Aucun rôle',
  Welcome: 'Bienvenue',
  'Here is what needs your attention today.': 'Voici ce qui requiert votre attention aujourd’hui.',
  'Your next steps': 'Vos prochaines étapes',
  Today: 'Aujourd’hui',
  'Workspace overview': 'Aperçu de l’espace de travail',
  'Recent activity': 'Activité récente',
  'New inquiry': 'Nouvelle demande',
  'Review supplier offers': 'Examiner les offres fournisseurs',
  'Send customer quotation': 'Envoyer le devis au client',
  'Review pending quotations': 'Examiner les devis en attente',
  'Confirm trip arrangements': 'Confirmer les préparatifs du voyage',
  'Active trips': 'Voyages actifs',
  'Departing this week': 'Départs cette semaine',
  'Quoted this month': 'Devis ce mois-ci',
  'Awaiting approval': 'En attente d’approbation',
  'Client meeting': 'Réunion client',
  'Project update': 'Mise à jour du projet',
  'Flight hold expires': 'Expiration de la réservation de vol',
  'Supplier response': 'Réponse du fournisseur',
  'pending offers': 'offres en attente',
  'Trip arrangement confirmed': 'Organisation du voyage confirmée',
  'Supplier offer received': 'Offre fournisseur reçue',
  'Quotation updated': 'Devis mis à jour',
  Yesterday: 'Hier',
  ago: 'il y a',
  Profile: 'Profil',
  'Personal information': 'Informations personnelles',
  'Account information': 'Informations du compte',
  Language: 'Langue',
  English: 'Anglais',
  French: 'Français',
  Swahili: 'Swahili',
  Username: 'Nom d’utilisateur',
  Email: 'E-mail',
  Phone: 'Téléphone',
  'First name': 'Prénom',
  'Last name': 'Nom',
  Address: 'Adresse',
  Street: 'Rue',
  'House number': 'Numéro',
  'Postal code': 'Code postal',
  Country: 'Pays',
  City: 'Ville',
  'Not provided': 'Non renseigné',
  'Edit profile': 'Modifier le profil',
  'Save changes': 'Enregistrer les modifications',
  Save: 'Enregistrer',
  'Saving...': 'Enregistrement…',
  Cancel: 'Annuler',
  Close: 'Fermer',
  Edit: 'Modifier',
  Delete: 'Supprimer',
  Disable: 'Désactiver',
  Reactivate: 'Réactiver',
  Restore: 'Restaurer',
  'Delete permanently': 'Supprimer définitivement',
  Create: 'Créer',
  Add: 'Ajouter',
  Update: 'Mettre à jour',
  Back: 'Retour',
  Next: 'Suivant',
  Previous: 'Précédent',
  Actions: 'Actions',
  Status: 'Statut',
  Active: 'Actif',
  Inactive: 'Inactif',
  All: 'Tous',
  Name: 'Nom',
  Description: 'Description',
  Details: 'Détails',
  Role: 'Rôle',
  Roles: 'Rôles',
  Permissions: 'Autorisations',
  'Search users': 'Rechercher des utilisateurs',
  'Search customers': 'Rechercher des clients',
  'Search roles': 'Rechercher des rôles',
  Filters: 'Filtres',
  'Clear filters': 'Effacer les filtres',
  'No results found': 'Aucun résultat trouvé',
  'No data available': 'Aucune donnée disponible',
  'Loading...': 'Chargement…',
  Retry: 'Réessayer',
  'Current password': 'Mot de passe actuel',
  'New password': 'Nouveau mot de passe',
  'Confirm password': 'Confirmer le mot de passe',
  'Sign in': 'Se connecter',
  Password: 'Mot de passe',
  'Remember me': 'Se souvenir de moi',
  'Forgot password?': 'Mot de passe oublié ?',
  'Welcome back': 'Bon retour',
  'Profile updated successfully.': 'Profil mis à jour avec succès.',
  'The profile could not be updated.': 'Le profil n’a pas pu être mis à jour.',
  'Password changed successfully.': 'Mot de passe modifié avec succès.',
  'The password could not be changed.': 'Le mot de passe n’a pas pu être modifié.',
  'User restored successfully.': 'Utilisateur restauré avec succès.',
  'Role permissions updated successfully.': 'Autorisations du rôle mises à jour avec succès.',
  'Role deleted successfully.': 'Rôle supprimé avec succès.',
  'Company profile updated successfully.': 'Profil de l’entreprise mis à jour avec succès.',
  'Something went wrong while processing your request. Please try again later.':
    'Une erreur s’est produite lors du traitement de votre demande. Veuillez réessayer plus tard.',
  'Unable to reach the server. Please check your connection and try again.':
    'Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.',
  'Please check the information and try again.': 'Vérifiez les informations et réessayez.',
  'Your session has expired. Please sign in again.':
    'Votre session a expiré. Veuillez vous reconnecter.',
  'You do not have permission to perform this action.':
    'Vous n’êtes pas autorisé à effectuer cette action.',
  'The requested information could not be found.': 'Les informations demandées sont introuvables.',
  'The request could not be completed. Please try again.':
    'La demande n’a pas pu être traitée. Veuillez réessayer.',
  'The selected language is not supported.': 'La langue sélectionnée n’est pas prise en charge.',
  'Access denied': 'Accès refusé',
  'You do not have permission to view this page.':
    'Vous n’êtes pas autorisé à consulter cette page.',
  'Go to dashboard': 'Aller au tableau de bord',
  Itinerary: 'Itinéraire',
  Requirements: 'Besoins',
  Offers: 'Offres',
  Costing: 'Calcul des coûts',
  'Supplier Requests': 'Demandes fournisseurs',
  'Supplier Offers': 'Offres fournisseurs',
  'Create request': 'Créer une demande',
  'Request quotation': 'Demander un devis',
  Approve: 'Approuver',
  Reject: 'Rejeter',
  'Submit for approval': 'Soumettre pour approbation',
  'Send to customer': 'Envoyer au client',
  Draft: 'Brouillon',
  'Pending Approval': 'En attente d’approbation',
  Approved: 'Approuvé',
  Rejected: 'Rejeté',
  'Changes Requested': 'Modifications demandées',
  Amount: 'Montant',
  Currency: 'Devise',
  Total: 'Total',
  Date: 'Date',
  'Start date': 'Date de début',
  'End date': 'Date de fin',
  Travelers: 'Voyageurs',
  Notes: 'Notes',
  'Terms and conditions': 'Conditions générales',
  Page: 'Page',
  of: 'sur',
  'First page': 'Première page',
  'Last page': 'Dernière page',
  'Next page': 'Page suivante',
  'Previous page': 'Page précédente',
};

const sw: TranslationDictionary = {
  'Choose the language for your account.': 'Chagua lugha ya akaunti yako.',
  Continue: 'Endelea',
  'Language updated successfully.': 'Lugha imesasishwa kikamilifu.',
  'The language could not be updated. Please try again.':
    'Lugha haikuweza kusasishwa. Tafadhali jaribu tena.',
  'Change language': 'Badilisha lugha',

  Work: 'Kazi',
  Control: 'Udhibiti',
  System: 'Mfumo',
  Customers: 'Wateja',
  Customer: 'Mteja',
  Inquiries: 'Maulizo',
  Inquiry: 'Ulizo',
  Trips: 'Safari',
  Trip: 'Safari',
  Suppliers: 'Wasambazaji',
  Supplier: 'Msambazaji',
  Quotations: 'Nukuu',
  Quotation: 'Nukuu',
  Reports: 'Ripoti',
  Administration: 'Usimamizi',
  Users: 'Watumiaji',
  User: 'Mtumiaji',
  'Roles & Permissions': 'Majukumu na Ruhusa',
  Company: 'Kampuni',
  'Exchange Rates': 'Viwango vya Kubadilisha Fedha',
  'All quotations': 'Nukuu zote',
  'Manager approval': 'Idhini ya meneja',
  Dashboard: 'Dashibodi',
  'My Profile': 'Wasifu wangu',
  'Change Password': 'Badilisha nenosiri',
  'Sign out': 'Ondoka',
  Notifications: 'Arifa',
  'Close notification': 'Funga arifa',
  Search: 'Tafuta',
  'Search across the workspace': 'Tafuta katika nafasi ya kazi',
  'Global search is not connected yet': 'Utafutaji wa jumla bado haujaunganishwa',
  'No production results are shown until a cross-module search API is available.':
    'Hakuna matokeo halisi yanayoonyeshwa hadi API ya utafutaji wa moduli zote ipatikane.',
  'Customers, trips, suppliers, inquiries and quotations.':
    'Wateja, safari, wasambazaji, maulizo na nukuu.',
  'No role': 'Hakuna jukumu',
  Welcome: 'Karibu',
  'Here is what needs your attention today.': 'Haya ndiyo yanayohitaji umakini wako leo.',
  'Your next steps': 'Hatua zako zinazofuata',
  Today: 'Leo',
  'Workspace overview': 'Muhtasari wa eneo la kazi',
  'Recent activity': 'Shughuli za hivi karibuni',
  'New inquiry': 'Ulizo jipya',
  'Review supplier offers': 'Kagua ofa za wasambazaji',
  'Send customer quotation': 'Tuma nukuu kwa mteja',
  'Review pending quotations': 'Kagua nukuu zinazosubiri',
  'Confirm trip arrangements': 'Thibitisha mipango ya safari',
  'Active trips': 'Safari zinazoendelea',
  'Departing this week': 'Zinazoondoka wiki hii',
  'Quoted this month': 'Nukuu za mwezi huu',
  'Awaiting approval': 'Inasubiri idhini',
  'Client meeting': 'Mkutano wa mteja',
  'Project update': 'Taarifa ya mradi',
  'Supplier response': 'Jibu la msambazaji',
  'Flight hold expires': 'Muda wa kushikilia nafasi ya ndege unaisha',
  'pending offers': 'ofa zinazosubiri',
  ago: 'iliyopita',
  'Trip arrangement confirmed': 'Mpango wa safari umethibitishwa',
  'Supplier offer received': 'Ofa ya msambazaji imepokelewa',
  'Quotation updated': 'Nukuu imesasishwa',
  Yesterday: 'Jana',
  Profile: 'Wasifu',
  'Personal information': 'Taarifa binafsi',
  'Account information': 'Taarifa za akaunti',
  Language: 'Lugha',
  English: 'Kiingereza',
  French: 'Kifaransa',
  Swahili: 'Kiswahili',
  Username: 'Jina la mtumiaji',
  Email: 'Barua pepe',
  Phone: 'Simu',
  'First name': 'Jina la kwanza',
  'Last name': 'Jina la mwisho',
  Address: 'Anwani',
  Street: 'Mtaa',
  'House number': 'Nambari ya nyumba',
  'Postal code': 'Msimbo wa posta',
  Country: 'Nchi',
  City: 'Jiji',
  'Not provided': 'Haijatolewa',
  'Edit profile': 'Hariri wasifu',
  'Save changes': 'Hifadhi mabadiliko',
  Save: 'Hifadhi',
  'Saving...': 'Inahifadhi…',
  Cancel: 'Ghairi',
  Close: 'Funga',
  Edit: 'Hariri',
  Delete: 'Futa',
  Disable: 'Zima',
  Reactivate: 'Washa tena',
  Restore: 'Rejesha',
  'Delete permanently': 'Futa kabisa',
  Create: 'Unda',
  Add: 'Ongeza',
  Update: 'Sasisha',
  Back: 'Rudi',
  Next: 'Ifuatayo',
  Previous: 'Iliyotangulia',
  Actions: 'Vitendo',
  Status: 'Hali',
  Active: 'Hai',
  Inactive: 'Isiyotumika',
  All: 'Zote',
  Name: 'Jina',
  Description: 'Maelezo',
  Details: 'Maelezo',
  Role: 'Jukumu',
  Roles: 'Majukumu',
  Permissions: 'Ruhusa',
  'Search users': 'Tafuta watumiaji',
  'Search customers': 'Tafuta wateja',
  'Search roles': 'Tafuta majukumu',
  Filters: 'Vichujio',
  'Clear filters': 'Ondoa vichujio',
  'No results found': 'Hakuna matokeo yaliyopatikana',
  'No data available': 'Hakuna data inayopatikana',
  'Loading...': 'Inapakia…',
  Retry: 'Jaribu tena',
  'Current password': 'Nenosiri la sasa',
  'New password': 'Nenosiri jipya',
  'Confirm password': 'Thibitisha nenosiri',
  'Sign in': 'Ingia',
  Password: 'Nenosiri',
  'Remember me': 'Nikumbuke',
  'Forgot password?': 'Umesahau nenosiri?',
  'Welcome back': 'Karibu tena',
  'Profile updated successfully.': 'Wasifu umesasishwa.',
  'The profile could not be updated.': 'Wasifu haukuweza kusasishwa.',
  'Password changed successfully.': 'Nenosiri limebadilishwa.',
  'The password could not be changed.': 'Nenosiri halikuweza kubadilishwa.',
  'User restored successfully.': 'Mtumiaji amerejeshwa.',
  'Role permissions updated successfully.': 'Ruhusa za jukumu zimesasishwa.',
  'Role deleted successfully.': 'Jukumu limefutwa.',
  'Company profile updated successfully.': 'Wasifu wa kampuni umesasishwa.',
  'Something went wrong while processing your request. Please try again later.':
    'Hitilafu imetokea wakati wa kushughulikia ombi lako. Tafadhali jaribu tena baadaye.',
  'Unable to reach the server. Please check your connection and try again.':
    'Imeshindwa kufikia seva. Angalia muunganisho wako na ujaribu tena.',
  'Please check the information and try again.': 'Angalia taarifa na ujaribu tena.',
  'Your session has expired. Please sign in again.':
    'Kipindi chako kimeisha. Tafadhali ingia tena.',
  'You do not have permission to perform this action.': 'Huna ruhusa ya kufanya kitendo hiki.',
  'The requested information could not be found.': 'Taarifa iliyoombwa haikupatikana.',
  'The request could not be completed. Please try again.':
    'Ombi halikuweza kukamilika. Tafadhali jaribu tena.',
  'The selected language is not supported.': 'Lugha iliyochaguliwa haitumiki.',
  'Access denied': 'Ufikiaji umekataliwa',
  'You do not have permission to view this page.': 'Huna ruhusa ya kuona ukurasa huu.',
  'Go to dashboard': 'Nenda kwenye dashibodi',
  Itinerary: 'Ratiba',
  Requirements: 'Mahitaji',
  Offers: 'Ofa',
  Costing: 'Ukokotoaji wa gharama',
  'Supplier Requests': 'Maombi kwa wasambazaji',
  'Supplier Offers': 'Ofa za wasambazaji',
  'Create request': 'Unda ombi',
  'Request quotation': 'Omba nukuu',
  Approve: 'Idhinisha',
  Reject: 'Kataa',
  'Submit for approval': 'Wasilisha kwa idhini',
  'Send to customer': 'Tuma kwa mteja',
  Draft: 'Rasimu',
  'Pending Approval': 'Inasubiri idhini',
  Approved: 'Imeidhinishwa',
  Rejected: 'Imekataliwa',
  'Changes Requested': 'Mabadiliko yameombwa',
  Amount: 'Kiasi',
  Currency: 'Sarafu',
  Total: 'Jumla',
  Date: 'Tarehe',
  'Start date': 'Tarehe ya kuanza',
  'End date': 'Tarehe ya mwisho',
  Travelers: 'Wasafiri',
  Notes: 'Maelezo',
  'Terms and conditions': 'Sheria na masharti',
  Page: 'Ukurasa',
  of: 'kati ya',
  'First page': 'Ukurasa wa kwanza',
  'Last page': 'Ukurasa wa mwisho',
  'Next page': 'Ukurasa unaofuata',
  'Previous page': 'Ukurasa uliotangulia',
};

export const TRANSLATIONS: Readonly<Record<LanguageCode, TranslationDictionary>> = {
  en: {},
  fr,
  sw,
};
